import React from "react";
import { Table, Tag, Button, Dropdown, Menu } from "antd";
import { EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { RxStar } from "react-icons/rx";
import PageHeader from "../../components/pageheader/PageHeader";
import styles from "./PromotionsMockup.module.scss";
import { getOrganizationId } from "../../api/Helper";

const hardcodedPromotions = [
  {
    key: 5917,
    name: "Promo Regular - Verano liviano",
    externalId: "",
    origin: "Manual",
    status: "Creada",
    startDate: "2024-01-01",
    endDate: "2024-01-31",
    type: "Regular",
    analysis: { text: "Mejorable", color: "gold" },
    suggestion: "Ajustar precio a $1790. ROI esperado: +14.2%",
    roiExpected: 2.8,
    roiObtained: 1.9,
  },
  {
    key: 5918,
    name: "BOGO - Medias x 3",
    externalId: "",
    origin: "Manual",
    status: "Creada",
    startDate: "2024-02-01",
    endDate: "2024-02-28",
    type: "BOGO",
    analysis: { text: "Ineficiente", color: "red" },
    suggestion: "Eliminar promoción. Alto costo por conversión, sin impacto positivo en unidades vendidas ni fidelización. Probabilidad de mejora estimada: <5%.",
    roiExpected: 2.3,
    roiObtained: 0.4,
  },
  {
    key: 5919,
    name: "MxN - 3x2 en Jeans",
    externalId: "",
    origin: "Manual",
    status: "Creada",
    startDate: "2024-03-01",
    endDate: "2024-03-31",
    type: "MxN",
    analysis: { text: "Eficiente", color: "green" },
    suggestion: "Asociar con categoría 'Remeras'. Ticket promedio esperado: +18.6%",
    roiExpected: 3.9,
    roiObtained: 4.2,
  },
  {
    key: 5920,
    name: "Descuento Progresivo - Accesorios",
    externalId: "",
    origin: "Manual",
    status: "Creada",
    startDate: "2024-04-01",
    endDate: "2024-04-30",
    type: "Progresivo",
    analysis: { text: "Mejorable", color: "gold" },
    suggestion: "Incluir billeteras y gafas. Activación estimada: x2",
    roiExpected: 3.1,
    roiObtained: 2.1,
  },
  {
    key: 5921,
    name: "Sugerida - Combo Deportivo",
    externalId: "",
    origin: "Sugerida",
    status: "Creada",
    startDate: "2024-05-01",
    endDate: "2024-05-31",
    type: "Sugerida",
    analysis: { text: "Eficiente", color: "green" },
    suggestion: "",
    roiExpected: 4.2,
    roiObtained: 4.0,
  },
  {
    key: 5922,
    name: "Sugerida - Rebaja por baja rotación",
    externalId: "",
    origin: "Sugerida",
    status: "Creada",
    startDate: "2024-06-01",
    endDate: "2024-06-30",
    type: "Sugerida",
    analysis: { text: "Eficiente", color: "green" },
    suggestion: "",
    roiExpected: 3.6,
    roiObtained: null,
  },
];

const columns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    render: (text: string, record: any) => (
      <a href={`/promotions/${record.key}/view`} style={{ color: "#1890ff" }}>{text}</a>
    ),
  },
  {
    title: "Id externo",
    dataIndex: "externalId",
    key: "externalId",
  },
  {
    title: "Origen",
    dataIndex: "origin",
    key: "origin",
    render: (origin: string) => (
      <Tag color={origin === "Sugerida" ? "blue" : "default"}>{origin}</Tag>
    ),
  },
  {
    title: "Estado",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Fecha de inicio",
    dataIndex: "startDate",
    key: "startDate",
  },
  {
    title: "Fecha de fin",
    dataIndex: "endDate",
    key: "endDate",
  },
  {
    title: "Tipo",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Análisis",
    dataIndex: "analysis",
    key: "analysis",
    render: (analysis: any) => (
      <Tag color={analysis.color}>{analysis.text}</Tag>
    ),
  },
  {
    title: "Sugerencia",
    dataIndex: "suggestion",
    key: "suggestion",
  },
  {
    title: "ROI Esperado",
    dataIndex: "roiExpected",
    key: "roiExpected",
    render: (roi: number) => roi !== null && roi !== undefined ? roi : "-",
  },
  {
    title: "ROI Obtenido",
    dataIndex: "roiObtained",
    key: "roiObtained",
    render: (roi: number | null) => roi !== null && roi !== undefined ? roi : "-",
  },
  {
    title: "Acciones",
    key: "action",
    render: (text: any, record: any) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="edit"
              onClick={() => {
                window.location.href = `/promotions/${record.key}/view`;
              }}
              icon={<EditOutlined />}
            >
              Editar
            </Menu.Item>
            <Menu.Item
              key="view"
              onClick={() => {
                window.location.href = `/promotions/${record.key}/view`;
              }}
              icon={<EyeOutlined />}
            >
              Ver
            </Menu.Item>
          </Menu>
        }
      >
        <Button
          onClick={(e) => e.preventDefault()}
          className={styles.actionButtonMore}
        >
          <MoreOutlined className={styles.actionIconMore} />
        </Button>
      </Dropdown>
    ),
  },
];

const PromotionsMockUp = () => {
  const [isOrg5, setIsOrg5] = React.useState(false);

  React.useEffect(() => {
    const fetchOrg = async () => {
      const orgId = await getOrganizationId();
      setIsOrg5(parseInt(orgId) === 5);
    };
    fetchOrg();
  }, []);

  return (
    <div className={styles.wrapper}>
      <PageHeader
        title="Promociones"
        icon={<RxStar />}
      />
      <div className={styles.contentWrapper}>
        <div className={styles.tableWrapper}>
          <Table
            size="small"
            className={styles.table}
            columns={columns}
            dataSource={isOrg5 ? hardcodedPromotions : []}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export default PromotionsMockUp;
